import { type FC, type ReactNode } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '~/redux/store';

export const ThemedLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const role = useSelector((state: RootState) => state.auth.user?.role);
  const themeClass = role === 'SELLER' ? 'seller-theme' : '';
  return <div className={`flex w-full ${themeClass}`}>{children}</div>;
};
